import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'split-taggle-status',
  templateUrl: './split-taggle-status.component.html',
  styleUrls: ['./split-taggle-status.component.scss']
})
export class SplitTaggleStatusComponent {

  @Input() style = '';
  @Input() listStatus: any[] = [
    {name: "Pendente", severity: "gray", key: "pending"},
    {name: "Agendado", severity: "primary", key: "scheduled"},
    {name: "Pago", severity: "success", key: "paid"},
    {name: "Vencido", severity: "danger", key: "overdue"},
    {name: "Cancelado", severity: "danger", key: "canceled"}
  ];

  @Input() public disabled: boolean = false;

  @Input() public filter: string[] = [];

  @ViewChild('op') public overlayPanel!: OverlayPanel;


  @Input() activeStatus: any = this.listStatus[0].key;

  @Output() onSelect = new EventEmitter<any>();

  setActiveStatus(position: number) {
    this.activeStatus = this.listStatus[position].key;
    this.onSelect.emit(this.activeStatus);
    this.overlayPanel.hide();
  }
  show(event: any) {
    if(!this.disabled) {
      this.overlayPanel.show(event);
    }
  }

}
